import { render } from "./TransactionPasswordModal.vue?vue&type=template&id=2f133d3c"
import script from "./TransactionPasswordModal.vue?vue&type=script&lang=js"
export * from "./TransactionPasswordModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__